export const priority = [
    {
        text: 'Urgent',
        value: '1',
    },
    {
        text: 'Regular',
        value: '2',
    },
    {
        text: 'Trivial',
        value: '3',
    },
]
